import React from "react";
import { Grid, TextField, TextFieldProps } from "@mui/material";

type BoxInputProps = TextFieldProps & {
  xs?: number;
  errorText?: string;
};

const BoxInput: React.FC<BoxInputProps> = ({
  xs = 12,
  errorText,
  multiline,
  rows,
  sx = {},
  ...props
}) => {
  return (
    <Grid item xs={xs}>
      <TextField
        fullWidth
        variant="outlined"
        error={!!errorText}
        helperText={errorText}
        placeholder={props.placeholder}
        multiline={multiline}
        rows={rows}
        // sx={{
        //   /* 🔥 ROOT INPUT */
        //   "& .MuiOutlinedInput-root": {
        //     borderRadius: "12px",
        //     background: "rgba(255,255,255,0.08)",

        //     ...(multiline
        //       ? {}
        //       : {
        //           height: "40px", // ✅ fixed height for normal input
        //         }),

        //     "& fieldset": {
        //       borderColor: "rgba(255,255,255,0.2)",
        //     },
        //     "&:hover fieldset": {
        //       borderColor: "rgba(255,255,255,0.4)",
        //     },
        //     "&.Mui-focused fieldset": {
        //       borderColor: "#0f63a5",
        //     },
        //   },

        //   /* 🔥 TEXT (INPUT + TEXTAREA SAME) */
        //   "& .MuiInputBase-input": {
        //     color: "#fff",
        //     fontSize: "14px",
        //     lineHeight: "1.4",

        //     ...(multiline
        //       ? {
        //           padding: "10px 12px", // ✅ textarea spacing
        //         }
        //       : {
        //           height: "40px",
        //           padding: "0 12px",
        //           display: "flex",
        //           alignItems: "center",
        //         }),
        //   },

        //   /* 🔥 FORCE MULTILINE CONSISTENCY */
        //   "& .MuiInputBase-inputMultiline": {
        //     fontSize: "14px",
        //     lineHeight: "1.5",
        //   },

        //   /* 🔥 PLACEHOLDER (INPUT) */
        //   "& .MuiInputBase-input::placeholder": {
        //     color: "rgba(255,255,255,0.6)",
        //     opacity: 1,
        //     fontSize: "14px",
        //   },

        //   /* 🔥 PLACEHOLDER (TEXTAREA) */
        //   "& .MuiInputBase-inputMultiline::placeholder": {
        //     color: "rgba(255,255,255,0.6)",
        //     opacity: 1,
        //     fontSize: "14px",
        //   },

        //   ...sx,
        // }}
        InputProps={{
              sx: {
                borderRadius: "12px",
                background: "rgba(255,255,255,0.08)",

                ...(multiline
                  ? {}
                  : {
                      height: "40px",
                    }),

                /* 🔥 FIX BACKGROUND ON FOCUS */
                "&.Mui-focused": {
                  background: "rgba(255,255,255,0.08)",
                },

                "& fieldset": {
                  borderColor: "rgba(255,255,255,0.2)",
                },
                "&:hover fieldset": {
                  borderColor: "rgba(255,255,255,0.4)",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "#0f63a5",
                },

                /* 🔥 TEXT + CURSOR FIX */
                "& input, & textarea": {
                  color: "#fff !important",
                  caretColor: "#fff", // cursor white
                  fontSize: "14px",
                  lineHeight: "1.4",
                },

                /* 🔥 PLACEHOLDER FIX */
                "& input::placeholder, & textarea::placeholder": {
                  color: "rgba(255,255,255,0.6)",
                  opacity: 1,
                  fontSize: "14px",
                },
              },
            }}
        sx={sx}
            {...props}
      />
    </Grid>
  );
};

export default BoxInput;